const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  // Add more environment-specific settings as needed
};

export default config;